import styled from 'styled-components';

export const LogoWrapper = styled.div`
    height: auto;
    padding: 10px 0;
    position: relative; 
    z-index: 10;
`;
